import { useEffect, useState } from 'react';
import { FaPauseCircle, FaPlayCircle } from 'react-icons/fa';
import { getS3 } from '../helpers/helpers';

const MP3 = (props) => {
  const { url } = props;
  const [audio, setAudio] = useState();
  const [playing, setPlaying] = useState(false);

  const loadAndPlay = async () => {
    const mp3 = await getS3(url);
    setAudio(new Audio(mp3));
  };

  useEffect(() => {
    if (audio) {
      audio.play();
      setPlaying(true);
    }
  }, audio);

  return (
    <>
      {!audio
    && (
    <button
      className="focus:outline-none"
      type="button"
      onClick={() => loadAndPlay()}
    >
      <FaPlayCircle className="text-4xl" />
    </button>
    )}
      {audio && playing
     && (
     <button
       className="focus:outline-none"
       type="button"
       onClick={() => {
         audio.pause();
         audio.currentTime = 0;
         setPlaying(false);
       }}
     >
       <FaPauseCircle className="text-4xl" />
     </button>
     )}
      {audio && !playing
    && (
    <button
      className="focus:outline-none"
      type="button"
      onClick={() => {
        audio.play();
        setPlaying(true);
      }}
    >
      <FaPlayCircle className="text-4xl" />
    </button>
    )}
    </>
  );
};

export default MP3;
